module.exports = __webpack_public_path__ + "img/dettol-liquid.a0738c07.jpg";